import { render, staticRenderFns } from "./LevelDifficult.vue?vue&type=template&id=627134fa&scoped=true&lang=pug&"
import script from "./LevelDifficult.vue?vue&type=script&lang=ts&"
export * from "./LevelDifficult.vue?vue&type=script&lang=ts&"
import style0 from "./LevelDifficult.vue?vue&type=style&index=0&id=627134fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627134fa",
  null
  
)

export default component.exports